module.exports = __webpack_public_path__ + "img/DSC_2837-xl.35f572b0.png";